import type { Entitlements } from "@dailywars/core/entitlements/types";
import { createServerFn } from "@tanstack/react-start";

import { setRouteAction } from "#/lib/requestLogger.server";
import { resolveRequestGameContext } from "#/server/game/requestGameContext.server";

export const getMyEntitlements = createServerFn({ method: "GET" }).handler(
  async (): Promise<Entitlements> => {
    setRouteAction("get_entitlements");
    const { entitlements } = await resolveRequestGameContext();
    return entitlements;
  },
);
